/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type courses_EnrolledChildStatusResponse = {
    attendance_id?: string;
    child_avatar_url?: string;
    child_birthdate?: string;
    child_firstname?: string;
    child_id?: string;
    child_internal_id?: string;
    child_lastname?: string;
    enrollment_billing_type?: courses_EnrolledChildStatusResponse.enrollment_billing_type;
    enrollment_id?: string;
    has_attendance?: boolean;
    price_per_month?: number;
    price_per_unit?: number;
};
export namespace courses_EnrolledChildStatusResponse {
    export enum enrollment_billing_type {
        PER_MONTH = 'per_month',
        PER_UNIT = 'per_unit',
        FREE = 'free',
    }
}

